import api from './api';
import { Video } from '../types';

class VideoService {
  async getAll(params?: any): Promise<Video[]> {
    const response = await api.get('/videos/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getVideo(id: number): Promise<Video> {
    const response = await api.get(`/videos/${id}/`);
    return response.data;
  }

  async create(data: FormData): Promise<Video> {
    const response = await api.post('/videos/', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async update(id: number, data: FormData | Partial<Video>): Promise<Video> {
    const headers = data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {};
    const response = await api.patch(`/videos/${id}/`, data, { headers });
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/videos/${id}/`);
  }

  async duplicate(id: number): Promise<Video> {
    const response = await api.post(`/videos/${id}/duplicate/`);
    return response.data;
  }

  async reorder(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/videos/reorder/', { items });
  }

  async getAvailableVideos(): Promise<Video[]> {
    const response = await api.get('/videos/available/');
    return response.data;
  }
}

const videoService = new VideoService();
export default videoService;
